import {Component, Inject, OnInit} from '@angular/core';
import {NpaDatabase, NpaDataSource} from '../../classes/npa-table';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup} from '@angular/forms';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {AvrcsSearchDialogService} from './avrcs-search-dialog.service';
import {NotificationsService} from '../../services/notifications.service';
import {composeMessage} from "../../consts/errors";

@Component({
    selector: 'app-avrcs-search-dialog',
    templateUrl: './avrcs-search-dialog.component.html',
    styleUrls: ['./avrcs-search-dialog.component.styl']
})
export class AvrcsSearchDialogComponent implements OnInit {
    displayedColumns: string[] = ['operations', 'id', 'contractor_name', 'v_pin', 'country'];
    dataSource: NpaDataSource;
    database: NpaDatabase;
    form: FormGroup;
    isLoading = false;
    isFocus = false;

    constructor(public dialogRef: MatDialogRef<AvrcsSearchDialogComponent>,
                private formBuilder: FormBuilder,
                public notificationsService: NotificationsService,
                public avrcsSearchDialogService: AvrcsSearchDialogService,
                @Inject(MAT_DIALOG_DATA) public dialogData) {
    }

    ngOnInit() {
        this.isLoading = true;
        this.notificationsService.startLoading();
        this.initForm();
        if (this.dialogData.load !== undefined) {
            this.dialogData.load(this.dialogData.args).subscribe((data: HttpResponse<any>) => {
                this.database = new NpaDatabase(data);
                this.dataSource = new NpaDataSource(this.database);
                this.isLoading = false;
                this.notificationsService.dismissLoading();
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notificationsService.error(composeMessage(error));
            });
        } else {
            this.isLoading = false;
            this.notificationsService.dismissLoading();
        }
    }

    initForm() {
        this.form = this.formBuilder.group({
            contractor_v_pin: undefined,
            contractor_name: undefined,
        } as any);
    }

    search() {
        this.isLoading = true;
        if (this.dialogData.load !== undefined) {
            this.dialogData
                .load(this.dialogData.args, this.avrcsSearchDialogService.convertToSearchParams(this.form.value))
                .subscribe((data: HttpResponse<any>) => {
                    this.database = new NpaDatabase(data);
                    this.dataSource = new NpaDataSource(this.database);
                    this.isLoading = false;
                }, (error: HttpErrorResponse) => {
                    this.isLoading = false;
                    this.notificationsService.error(composeMessage(error));
                });
        } else {
            this.avrcsSearchDialogService.avrcsVendorsData(this.form.value).subscribe((data) => {
                this.database = new NpaDatabase(data.body);
                this.dataSource = new NpaDataSource(this.database);
                this.isLoading = false;
            }, (error: HttpErrorResponse) => {
                console.error(error);
                this.notificationsService.error(composeMessage(error));
                this.isLoading = false;
            });
        }
    }

    confirm(row) {
        this.dialogRef.close({
            status: true,
            data: row
        });
    }

}
